import { render, staticRenderFns } from "./CertificateRecordSub.vue?vue&type=template&id=138a1b8a"
import script from "./CertificateRecordSub.vue?vue&type=script&lang=js"
export * from "./CertificateRecordSub.vue?vue&type=script&lang=js"
import style0 from "./CertificateRecordSub.vue?vue&type=style&index=0&id=138a1b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports